'use es6';

class CookieSetError extends Error {
  constructor(message) {
    super(message || 'Could not set cookie');
    this.name = 'CookieSetError';
  }

}

export default CookieSetError;